"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rgb2hex = exports.rgbComponentsToHex = exports.hexToRgbComponents = void 0;
function hexToRgbComponents(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
        }
        : { r: 0, g: 0, b: 0 };
}
exports.hexToRgbComponents = hexToRgbComponents;
function componentToHex(c) {
    const hex = c.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
}
function rgbComponentsToHex(color) {
    const components = color.split(',');
    const r = parseInt(components[0]);
    const g = parseInt(components[1]);
    const b = parseInt(components[2]);
    return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
}
exports.rgbComponentsToHex = rgbComponentsToHex;
const rgb2hex = (rgb) => {
    if (!/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/.test(rgb)) {
        return rgb;
    }
    const [r, g, b] = rgb.match(/\d+/g).map(value => {
        return Number(value);
    });
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};
exports.rgb2hex = rgb2hex;
